import { getMenuList, logOut, queryByAccount, queryUserPlatform } from '@/api/login'
// import { findDictionaryTypeVOListByPlatformId } from '@/api/platform'
import { getCookie, setCookie, setToken } from '@/libs/auth'
import { Message } from 'element-ui'

export default {
  state: {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    loginInfo: localStorage.getItem('loginInfo') ? JSON.parse(localStorage.getItem('loginInfo')) : {},
    oauthList: [],
    meunList: [],
    oauthMenuBtn: {},
    oauthMenuBtnNew: {},
    menuIndex: '',
    userPlatformList: localStorage.getItem('platformNameList') ? JSON.parse(localStorage.getItem('platformNameList')) : [],
    privilegeFunctionPointsMap: new Map(),
    dictionaryList: []
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    loginInfo: state => state.loginInfo,
    oauthList: state => state.oauthList,
    meunList: state => state.meunList,
    oauthMenuBtn: state => state.oauthMenuBtn,
    oauthMenuBtnNew: state => state.oauthMenuBtnNew,
    menuIndex: state => state.menuIndex,
    userPlatformList: state => state.userPlatformList,
    dictionaryList: state => state.dictionaryList
  },
  mutations: {
    setUserInfo(state, info) {
      localStorage.setItem('userInfo', JSON.stringify(info))
      state.userInfo = info
    },
    setOauthList(state, oauthList) {
      state.oauthList = oauthList
    },
    setMeunList(state, meunList) {
      state.meunList = meunList
    },
    setOauthMenuBtn(state, oauthMenuBtn) {
      state.oauthMenuBtn = oauthMenuBtn
    },
    setOauthMenuBtnNew(state, oauthMenuBtnNew) {
      state.oauthMenuBtnNew = oauthMenuBtnNew
    },
    setUserPrivilege(state, privilegeList) {
      privilegeList.map(item => {
        const m = item.children.map(vo => {
          return vo.pageCode
        })
        state.privilegeFunctionPointsMap.set(item.pageCode, m)
      })
    },
    setMenuIndex(state, menuIndex) {
      state.menuIndex = menuIndex
    },
    setLoginInfo(state, loginInfo) {
      sessionStorage.setItem('loginInfo', JSON.stringify(loginInfo))
      state.loginInfo = loginInfo
    },
    setUserPlatformList(state, userPlatformList) {
      state.userPlatformList = userPlatformList
    },
    setDictionaryList(state, dictionaryList) {
      state.dictionaryList = dictionaryList
    }
  },
  actions: {
    setLoginInfo({ commit }, loginInfo) {
      setToken(loginInfo.access_token)
      setCookie({ name: 'token_type', value: loginInfo.token_type })
      setCookie({
        name: 'refresh_token',
        value: loginInfo.refresh_token
      })
      commit('setLoginInfo', loginInfo)
    },
    getMenu({ commit }) {
      return new Promise((resolve, reject) => {
        getMenuList({ appCode: 'saas' }).then(res => {
          const _ = []

          const oauth = []
          res.data.map(item => {
            oauth[item.pageCode] = item.children
          })
          commit('setOauthList', oauth)
          commit('setUserPrivilege', res.data);

          (res.data || []).map((v, k) => {
            const name = v.pageName.split('-')
            if (name.length > 1) {
              if (k === 0) {
                _.push({
                  pageName: name[0],
                  pageCode: k + '',
                  level: 1,
                  children: [{
                    level: v.level,
                    linkType: v.linkType,
                    pageCode: v.pageCode,
                    pageName: name[1],
                    sortNum: v.sortNum,
                    urlPath: v.urlPath,
                    btnChildren: [...v.children]
                  }]
                })
              } else {
                let flag = false
                let row = {}
                _.map((item, key) => {
                  if (item.pageName === name[0]) {
                    flag = true
                    row = item
                  }
                })
                if (flag) {
                  row.children.push({
                    level: v.level,
                    linkType: v.linkType,
                    pageCode: v.pageCode,
                    pageName: name[1],
                    sortNum: v.sortNum,
                    urlPath: v.urlPath,
                    btnChildren: [...v.children]
                  })
                } else {
                  _.push({
                    pageName: name[0],
                    pageCode: k + '',
                    level: 1,
                    children: [{
                      level: v.level,
                      linkType: v.linkType,
                      pageCode: v.pageCode,
                      pageName: name[1],
                      sortNum: v.sortNum,
                      urlPath: v.urlPath,
                      btnChildren: [...v.children]
                    }]
                  })
                }
              }
            } else {
              _.push({
                linkType: v.linkType,
                pageCode: v.pageCode,
                pageName: v.pageName,
                sortNum: v.sortNum,
                urlPath: v.urlPath,
                btnChildren: [...v.children]
              })
            }
          })
          commit('setMeunList', _)

          resolve()
        })
      })
    },
    getUserDetailInfo({ commit }, info) {
      return new Promise((resolve, reject) => {
        queryByAccount(info).then(res => {
          commit('setUserInfo', res.data)
          resolve()
        })
      })
    },
    getUserPlatform({ commit }, info) {
      return new Promise((resolve, reject) => {
        queryUserPlatform().then(res => {
          const { data: d } = res
          const list = []
          d.map(item => {

            if (item.platformCode === 'zhongtai' || item.platformCode === "biaozhunnengyuanzhan" ||
              item.platformCode === "guoluyun") {
              list.push({
                id: 1,
                platformCode: "zhongtai",
                platformName: "Wonder Cloud平台",
                platformUrl: "zhongtai"
              })
            } else list.push(item)
          })
          commit('setUserPlatformList', list)
          localStorage.setItem('platformNameList', JSON.stringify(list))

          // const codes = d.map((item) => item.appCode)
          resolve(d)
        })
      })
    },
    // 获取字典
    getDictionaryList({ commit }) {
      return new Promise((resolve, reject) => {
        findDictionaryTypeVOListByPlatformId({ platformId: (getCookie('platfromId') || 1) }).then(async res => {
          await commit('setDictionaryList', res.data)
        })
      })
    },
    // 退出登录
    handleLogOut() {
      logOut({}).then(
        (res) => {
          // Message({
          //   message: '退出成功',
          //   type: 'success'
          // })
          setToken('')
          location.href = window.location.origin + '/portal/#/login'
        },
        (err) => {
          Message.error(err.msg)
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js